module.exports = __webpack_public_path__ + "static/img/code.ff0851d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/code.jpg
// module id = Wkf9
// module chunks = 3